import React from 'react';
import { fetchTranslation } from 'common/locale';
import { ForgeDialog, ForgeIconButton, ForgeButton, ForgeToolbar } from '@tylertech/forge-react';
import './UnappliedChangesModal.scss';
import { ForgeScaffold, ForgeIcon } from '@tylertech/forge-react';

const t = (k: string) => fetchTranslation(k, 'shared.components.unapplied_changes_modal');

export interface NavigationOptions {
  navigateOnApply: boolean,
  navigateOnDiscard: boolean
}
export type NavigateWithUnappliedChanges = (callback: () => void, partialOptions?: Partial<NavigationOptions>) => void;
export const buildNavigationOptions = (partialOptions: Partial<NavigationOptions> = {}) => ({
  navigateOnApply: false,
  navigateOnDiscard: true,
  ...partialOptions
});

export interface UnappliedChangesModalProps {
  isOpen: boolean;
  onPrimaryAction: () => void;
  onDiscardChanges: () => void;
  onDismiss: () => void;
  title?: string;
  bodyText?: string;
  affirmativeButtonText?: string;
  affirmativeButtonType?: 'raised' | 'outlined';
}

export default function UnappliedChangesModal(props: UnappliedChangesModalProps) {
  const {
    isOpen,
    onPrimaryAction,
    onDiscardChanges,
    onDismiss,
    title = t('title'),
    bodyText = t('body'),
    affirmativeButtonText = t('apply_changes'),
    affirmativeButtonType = 'outlined'
  } = props;

  return (
    <ForgeDialog
      on-forge-dialog-close={onDismiss}
      open={isOpen}
      aria-labelledby='unapplied-changes-dialog-title'
      aria-describedby='unapplied-changes-dialog-message'
      data-testid='unapplied-changes-modal'
    >
      <ForgeScaffold>
        <ForgeToolbar slot='header' no-divider>
          <h1 className="forge-typography--heading4 modal-title" id='unapplied-changes-dialog-title' slot="start">
            {title}
          </h1>
          <ForgeIconButton slot="end" onClick={onDismiss} aria-label={t('cancel')} data-testid='unapplied-changes-modal-x-button'>
            <ForgeIcon name='close' />
          </ForgeIconButton>
        </ForgeToolbar>
        <div slot='body' className="modal-body-text">
          <p id='unapplied-changes-dialog-message' className="forge-typography--body1">
            {bodyText}
          </p>
        </div>
        <ForgeToolbar inverted={true} slot='footer' no-divider>
          <ForgeButton
            variant="outlined"
            onClick={onDiscardChanges}
            className="discard-changes"
            slot="end"
            style={{ marginRight: '16px' }}
          >
            {t('discard_changes')}
          </ForgeButton>
          <ForgeButton
            variant={affirmativeButtonType}
            className="apply-changes"
            slot="end"
            onClick={onPrimaryAction}>
            {affirmativeButtonText}
          </ForgeButton>
        </ForgeToolbar>
      </ForgeScaffold>
    </ForgeDialog>
  );
}
